import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HupSubscription} from "../../../data/models/subscription.model";
import {TranslationService} from "../../services/translation.service";

@Component({
  selector: 'app-subscription-card',
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.css']
})
export class SubscriptionCardComponent {
  @Input() subscription: HupSubscription;
  /** Beschriftung des Aktionsbuttons – der Aufrufer liefert den übersetzten Text. Ohne Beschriftung entfällt der Button. */
  @Input() actionLabel: string = '';
  /** Übersetzte Überschrift über dem Titel (z. B. "Ihr Hauptabonnement"). Ohne Text entfällt sie. */
  @Input() label: string = '';
  /** Nur den Titel (Produktbezeichnung) zeigen, ohne Auftragsnummer, Ausgabe, Zeitraum und Adresse. */
  @Input() titleOnly: boolean = false;
  /** Klick auf den Aktionsbutton. Gibt das Abo der Karte mit, damit der Aufrufer weiß, welches gemeint ist. */
  @Output() action = new EventEmitter<HupSubscription>();

  constructor(protected translationService: TranslationService) {}
}
